import React from 'react';
import { Toolbar, Button } from '@material-ui/core';
import { simpleUrl } from '../../../../config/paths';
import { useButtonHeaderStyles } from './styles';

const ButtonHeader = () => {
  const classes = useButtonHeaderStyles();
  return (
    <Toolbar className={classes.root} variant="dense">
      <Button
        className={classes.button}
        onClick={() => window.open(simpleUrl, '_blank')}
      >
        Ripley.com
      </Button>
      <Button
        className={classes.button}
        onClick={() => window.open(process.env.REACT_APP_URL_BANCO, '_blank')}
      >
        Banco Ripley
      </Button>
    </Toolbar>
  );
};

export default ButtonHeader;
